import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, user, exitImpersonation } = useAuth();

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="bg-accent-yellow text-dark-bg px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2">
        {/* Eye icon */}
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          />
        </svg>
        <span className="text-sm font-medium">
          Viewing as: <strong>{user?.username}</strong>
          {user?.email && <span className="opacity-75"> ({user.email})</span>}
        </span>
      </div>
      <button
        onClick={exitImpersonation}
        className="flex items-center gap-1 px-3 py-1 text-sm font-medium bg-dark-bg text-accent-yellow rounded hover:bg-dark-surface transition-colors"
      >
        {/* X icon */}
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        Exit
      </button>
    </div>
  );
};
